import type { ComponentType } from 'react';
import { AppCoreAccountField, AppCoreCampaignField } from './AppCoreLinkedField';
import { AppImageSelectArray } from './AppImageSelectArray';
import { IMAGE_SELECT_WIDGET, X_UI_WIDGET } from '../../../utils/schemaExtensions';

export { AppImageSelectArray } from './AppImageSelectArray';

export const resolveAppWidget = (node: Record<string, any>, pointer: string): ComponentType<any> | undefined => {
    if (node[X_UI_WIDGET] === IMAGE_SELECT_WIDGET) {
        return AppImageSelectArray;
    }
    const propertyName = pointer.split('/').pop() ?? '';
    if (node.type === 'string' && propertyName.includes('coreAccountId')) {
        return AppCoreAccountField;
    }
    if (node.type === 'string' && propertyName.includes('originatingcampaign')) {
        return AppCoreCampaignField;
    }
    return undefined;
};
